import { getPermission, getPermissionInterface } from '@/api/auth'
import subMenuList from '@/menu/menu'
import customMenuMap from '@/menu/menuCustom'
function getMenusMap (menu) {
  let menusMap = {}
  for (let i of menu) {
    menusMap[i.url] = i
    if (i.subset && i.subset.length) for (let ii of i.subset) menusMap[ii.url] = ii
  }
  console.log('menusMap', menusMap)
  return menusMap
}

const menu = {
  state: {
    menus: [],
    wheight: localStorage.getItem('wheight'),
    wwidth: localStorage.getItem('wwidth'),
    globalMenuType: 'wechat',
    hasHeader: false,
    menusMap: {}
  },

  mutations: {
    setMenu (state, payload) {
      state.menus = payload.menus
      this.commit('setMenuMap', { menusMap: getMenusMap(payload.menus) })
    },
    setMenuMap (state, payload) {
      state.menusMap = payload.menusMap
    },
    setGlobalHeader (state, payload) {
      state.hasHeader = payload
    },
    clearMenu (state, payload) {
      state.menus = []
    },
    setWidth: (state, width) => {
      state.wwidth = width
      localStorage.setItem('wwidth', width)
    },
    setHeight: (state, height) => {
      state.wheight = height
      localStorage.setItem('wheight', height)
    },
    setGlobalMenuType: (state, type) => {
      state.globalMenuType = type
    }
  },

  actions: {
    async getPermission ({ commit }) {
      const permission = await getPermission()
      // 菜单接口
      if (permission.list) {
        commit('setMenu', {
          //合并前端静态权限
          menus: permission.list
        })
      } else {
        commit('setMenu', { menus: permission.concat(subMenuList) })
        // commit('setMenuMap', {menusMap:getMenusMap(permission.concat(subMenuList))})
      }
    },
    async getPermissionInterface ({ commit }) {
      const permission = await getPermissionInterface()
      permission.unshift({ name: '首页', url: '/', is_show: 1, alias_name: 'index', id: 1 })
      console.log('getPermissionInterface-run', permission)

      // 菜单接口
      if (permission) {
        //增加前端静态路由
        // let menuData = Object.values(customMenuMap['defineRouter']).concat(permission)
        let menuData = permission
        //增加临时开发路由
        if (process.env.NODE_ENV === 'development') {
          menuData = Object.values(customMenuMap['devRouter']).concat(menuData)
        }
        commit('setMenu', {
          menus: menuData
        })

        // commit('setMenuMap', {menusMap:getMenusMap(menuData)})
      }
    },
    setMenu ({ commit }, menu) {
      commit('setMenu', menu)
    },
    setWidth ({ commit }, width) {
      commit('setWidth', width)
    },
    setHeight ({ commit }, height) {
      commit('setHeight', height)
    }
  }

  // getters: {
  //   menus(state) {
  //     return state.menus
  //   },
  //   wheight(state) {
  //     return state.wheight
  //   },
  //   wwidth(state) {
  //     return state.wwidth
  //   }
  // }
}

export default menu
